import { defineNuxtMiddleware } from '@nuxtjs/composition-api'

export default defineNuxtMiddleware((context) => {
  if (process.env.NODE_ENV === 'production' && !context.$cookies.get('devMode'))
    context.redirect(302, '/404')
})
